import PropTypes from 'prop-types';

export const historyPropTypes = PropTypes.shape({
  push: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  length: PropTypes.number.isRequired,
});
